<template>
  <div>
    <el-row :gutter="20" v-for="(token, key, index) in tokens" :key="index">
      <el-col :span="10">
        <el-input size="mini" :value="key" type="text" :readonly="true" />
      </el-col>
      <el-col :span="10">
        <el-input v-model="tokens[key]" type="text" size="mini" placeholder="Input Test Value" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * TokenExtractor - Test data input for template variable substitution during API preview.
 *
 * @component
 * @description Simple key-value input grid for providing test values for template variables found
 * in API URL or body (e.g., {{ userId }}, {{ apiKey }}). Keys are read-only (extracted from template),
 * values are editable inputs for testing purposes.
 *
 * @prop {Object} tokens - Object mapping template variable names to test values
 *
 * @example
 * <TokenExtractor
 *   :tokens="templateVars"
 * />
 */

export default {
  props: ["tokens"],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style></style>
